// Helpers to compute the "Si paga con..." preview using the shared pure function.
// Kept here so the SaleView can show tentative totals for each payment method
// with discount without persisting anything.

import type { PaymentMethod } from "../payment-methods/api";
import type { SaleDraftItem } from "../sale/draft-store";
import { computeSaleTotals } from "@ventas/shared/domain";

export type MethodPreview = {
  paymentMethod: PaymentMethod;
  totalChargedCents: number;
  // The discount that would be applied if `discountApplied: true`.
  // null if the method has no discount configured.
  discountCents: number | null;
  eligibleBaseCents: number;
};

export function previewByMethod(
  items: SaleDraftItem[],
  globalDiscountCents: number,
  methods: PaymentMethod[]
): MethodPreview[] {
  if (globalDiscountCents > 0) return [];
  return methods
    .filter((m) => m.discountPct > 0)
    .map((m) => {
      const eligibleBaseCents = items.reduce(
        (total, item) => item.lineDiscountCents === 0
          ? total + item.qty * item.unitPriceCents
          : total,
        0
      );
      const t = computeSaleTotals({
        items: items.map((it) => ({
          productId: it.productId,
          unitPriceCents: it.unitPriceCents,
          qty: it.qty,
          lineDiscountCents: it.lineDiscountCents * it.qty,
        })),
        globalDiscountCents,
        paymentMethod: {
          discountPct: m.discountPct,
          requiresNetReceived: m.requiresNetReceived,
        },
        paymentMethodDiscountApplied: true,
      });
      return {
        paymentMethod: m,
        totalChargedCents: t.totalChargedCents,
        discountCents: t.paymentMethodDiscountCents,
        eligibleBaseCents,
      };
    });
}
